<template>
  <div class="tab-wrap">
    <van-tabs
      title-active-color="#FFFFFF"
      title-inactive-color="#FFDABD"
      animated
      type="line"
      color="#FFFFFF"
      line-width="20"
      line-height="4"
      :active="activeIndex"
      @change="typeChange">
      <van-tab title="主页" type="0"></van-tab>
      <van-tab title="推广位管理" type="1"></van-tab>
      <van-tab title="推广位报表" type="2"></van-tab>
      <van-tab title="推广订单" type="3"></van-tab>
      <van-tab title="资金明细" type="4"></van-tab>
      <van-tab title="账户充值" type="5"></van-tab>
      <van-tab title="个人设置" type="6"></van-tab>
    </van-tabs>
  </div>
</template>

<script>
  import { getToken } from '@/utils/auth'
  export default {
    name: 'Tab',
    data(){
      return{
        //activeIndex: 0,
        currentTab: ''
      }
    },
    computed:{
      activeIndex: function () {
        return this.$store.getters.tabPromotionActiveIndex
      },
    },
    watch: {
      $route: function (to, from) {
        var path = to.path
        this.getCurIndex(path)
      }
    },
    mounted: function () {
      var path = this.$route.path
      this.getCurIndex(path)
    },
    methods:{
      getCurIndex(path){
        var index = 0;
        switch (path) {
          case '/h5/promotion/home':
            index = 0
            break;
          case '/h5/promotion/manage':
            index = 1
            break;
          case '/h5/promotion/report':
            index = 2
            break;
          case '/h5/promotion/order':
            index = 3
            break;
          case '/h5/promotion/money':
            index = 4
            break;
          case '/h5/promotion/account':
            index = 5
            break
          case '/h5/promotion/setting':
            index = 6
            break
          default:
            index = 0
        }
        this.$store.dispatch('h_nav/changePromotionActiveIndex',index)
        if(!this.$pc){
          this.typeChange(index)
        }
      },
      typeChange(index){
        var that = this
        var isNext = true
        var token = getToken()
        if (token === undefined || token === '') {
          isNext = false
          // 弹窗提示
          this.$dialog.alert({
            title: '提示',
            message: '您还未登录，请先登录！',
            theme: 'round-button',
          }).then(() => {
            // on close
            this.$router.push('/h5/login')
          })
        }
        if (isNext == false) {
          return
        }

        var url = '/h5/promotion/home';
        switch (index) {
          case 0:
            url = '/h5/promotion/home'
            break;
          case 1:
            url = '/h5/promotion/manage'
            break;
          case 2:
            url = '/h5/promotion/report'
            break;
          case 3:
            url = '/h5/promotion/order'
            break;
          case 4:
            url = '/h5/promotion/money'
            break;
          case 5:
            url = '/h5/promotion/account'
            break;
          case 6:
            url = '/h5/promotion/setting'
            break;
        }
        this.$store.dispatch('h_nav/changePromotionActiveIndex',index)
        this.$router.push(url).catch(err => { err })
      },
    }
  }
</script>

<style lang="less" scoped>
  .tab-wrap{
    width: calc(100%);
    height: 44px;
    background: #FF8622;
    box-shadow: 0 1px 0 0 #E8E8E8;
    top: 44px;
    z-index: 1;
    font-family: Alibaba-PuHuiTi-R;
  }
  /deep/.van-tabs{
    background-color:#FF8622;
  }
  /deep/.van-tabs__wrap{
    width: 100%;
    height: 34px;
    line-height: 34px;
    background: #FF8622;
  }
  /deep/.van-tab--active{
    font-size: 15px;
  }
  /deep/.van-tabs__nav{
    background-color:#FF8622;
  }
</style>



// WEBPACK FOOTER //
// src/components/h5/Tab.vue